import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Uses localStorage
import dataReducer from "./dataSlice";
import applicationProcessReducer from "./applicationProcess";

const persistConfig = {
  key: "root",
  storage,
  blacklist: ["applicationProcess"], // applicationProcess should not be persisted
};

// Combine reducers before persisting
const rootReducer = combineReducers({
  data: dataReducer,
  applicationProcess: applicationProcessReducer,
});

// Apply persistReducer to the combined root reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer, // Use the persisted root reducer
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export { store, persistor };
export default store;
